// Data Visualization Types
import { ImageProvider } from './images';

export type ChartType = 'bar' | 'line' | 'pie' | 'table' | 'area';

export interface ParsedDataset {
  id: string;
  name: string;
  sourceFileId?: string;
  headers: string[];
  rows: Array<Record<string, string | number>>;
}

export interface ChartConfig {
  chartType: ChartType;
  datasetId: string;
  xAxis?: string;
  yAxis?: string | string[];
  labelColumn?: string;
  valueColumn?: string;
  title?: string;
  showLegend?: boolean;
  colors?: string[];
}

export interface TableConfig {
  datasetId: string;
  columns?: string[];
  maxRows?: number;
  striped?: boolean;
}

export type VisualBlockType = 'image' | 'chart' | 'table';

export interface VisualBlockBase {
  id: string;
  sectionId: number;
  type: VisualBlockType;
  position: 'before' | 'after' | 'middle';
  width: 'small' | 'medium' | 'large' | 'full';
  alignment: 'left' | 'center' | 'right';
  caption?: string;
}

export interface ImageVisualBlock extends VisualBlockBase {
  type: 'image';
  imageUrl: string;
  generatedPrompt?: string;
  provider?: ImageProvider;
}

export interface ChartVisualBlock extends VisualBlockBase {
  type: 'chart';
  config: ChartConfig;
}

export interface TableVisualBlock extends VisualBlockBase {
  type: 'table';
  config: TableConfig;
}

export type VisualBlock = ImageVisualBlock | ChartVisualBlock | TableVisualBlock;

// Helper type guards
export function isImageBlock(block: VisualBlock): block is ImageVisualBlock {
  return block.type === 'image';
}

export function isChartBlock(block: VisualBlock): block is ChartVisualBlock {
  return block.type === 'chart';
}

export function isTableBlock(block: VisualBlock): block is TableVisualBlock {
  return block.type === 'table';
}
